import queries from './queries';

/**
 * Check if this is a mobile device.
 * @return {Boolean}
 */
export function isMobile() {
    return window.matchMedia(queries.xs + ', ' + queries.sm + ', ' + queries.md).matches;
}

/**
 * Check if the the device is a tablet.
 * @return {Boolean}
 */
export function isTablet() {
    return window.matchMedia(queries.lg).matches;
}

/**
 * Check if the the device is mobile or a tablet.
 * @return {Boolean}
 */
export function isMobileOrTablet() {
    return window.matchMedia(queries.xs + ', ' + queries.sm + ', ' + queries.md + ', ' + queries.lg)
        .matches;
}

/**
 * Check if this is a desktop device.
 * @return {Boolean}
 */
export function isDesktop() {
    return window.matchMedia(queries.xl).matches;
}

/**
 * Check if the the device is a tablet or desktop.
 * @return {Boolean}
 */
export function isTabletOrDesktop() {
    return window.matchMedia(queries.lg + ', ' + queries.xl).matches;
}
